import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconSuccess = /*@__PURE__*/ proxyCustomElement(class WppIconSuccess extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-success-color-400)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-success", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.5 10C1.5 5.30558 5.30558 1.5 10 1.5C14.6944 1.5 18.5 5.30558 18.5 10C18.5 14.6944 14.6944 18.5 10 18.5C5.30558 18.5 1.5 14.6944 1.5 10ZM13.8321 8.83046C14.2226 8.43993 14.2226 7.80677 13.8321 7.41625C13.4416 7.02572 12.8084 7.02572 12.4179 7.41625L8.95833 10.8758L7.58211 9.49958C7.19158 9.10905 6.55842 9.10905 6.16789 9.49958C5.77737 9.8901 5.77737 10.5233 6.16789 10.9138L8.25123 12.9971C8.64175 13.3876 9.27492 13.3876 9.66544 12.9971L13.8321 8.83046Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-success-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-success", "wpp-icon-success-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-success-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-success-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconSuccess);
      }
      break;
  } });
}

export { WppIconSuccess as W, defineCustomElement as d };
